import cx from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/context/srp/ModalContext';

type OwnProps = {
  isFullBleed: boolean;
};

export default function HeaderOverlay({ isFullBleed }: OwnProps) {
  const { isSearchBarFocused } = useContext(ModalContext);

  return (
    <div
      className={cx(
        // This backdrop is only meant to cover the Header due to a stacking context issue between it and the search bar container, hence the '-top-80' and 'h-80' classes
        'pointer-events-none absolute -top-80 z-10 h-80 bg-canvas-overlay transition-all duration-300',
        isFullBleed ? 'left-1/2 w-screen -translate-x-1/2' : 'left-0 w-full',
        isSearchBarFocused ? 'opacity-100' : 'opacity-0'
      )}
    />
  );
}
